import React from 'react'
import { ReportIcon, DashboardIcon, InboxIcon, IncidentBoardIcon, DeviceIcon, FlowIcon, DatasetIcon, ModuleIcon, ModelIcon, ExperimentIcon, LocationIcon } from 'images/common'
import { UserIcon } from 'images/notifications'

export const recentActionsDefs = () => [
  {
    column: 'title',
    label: 'Title',
    type: 'text',
    mobile: 'title'
  },
  {
    column: 'caption',
    label: 'Caption',
    mobile: 'caption'
  }
]

export const recentActionsMap = {
  dashboard: {
    label: 'Dashboard',
    url: 'dashboards',
    icon: <DashboardIcon />
  },
  incident: {
    label: 'Incident Board',
    url: 'incident',
    icon: <IncidentBoardIcon />
  },
  incident_board: {
    label: 'Incident Board',
    url: 'incident',
    icon: <IncidentBoardIcon />
  },
  location: {
    label: 'Location',
    url: 'locations',
    icon: <LocationIcon />
  },
  device_image: {
    label: 'Device Image',
    url: 'device-images',
    noIdPage: true,
    icon: <DeviceIcon />
  },
  device: {
    label: 'Device',
    url: 'devices',
    icon: <DeviceIcon />
  },
  report: {
    label: 'Report',
    url: 'reports',
    icon: <ReportIcon />
  },
  profile: {
    label: 'Profile',
    url: 'profiles',
    icon: <InboxIcon />
  },
  application: {
    label: 'Application',
    url: 'applications',
    icon: <FlowIcon />
  },
  dataset: {
    label: 'Dataset',
    url: 'dataset',
    icon: <DatasetIcon />
  },
  jobTraining: {
    label: 'Model Training',
    url: 'job-training',
    icon: <ExperimentIcon />
  },
  model_training: {
    label: 'Model Training',
    url: 'job-training',
    icon: <ExperimentIcon />
  },
  module: {
    label: 'Module',
    url: 'modules',
    icon: <ModuleIcon />
  },
  model: {
    label: 'Model',
    url: 'models',
    icon: <ModelIcon />
  },
  ai_model: {
    label: 'AI Model',
    url: 'models',
    icon: <ModelIcon />
  },
  user: {
    label: 'User',
    url: 'settings/user',
    icon: <UserIcon />
  }
}

export const quickActionList = [
  {
    label: 'Create New',
    value: 'dataset/create',
    category: 'Datasets',
    badge: {
      color: 'accent3',
      text: 'Dataset'
    },
  },
  {
    label: 'Import',
    value: 'dataset/create',
    category: 'Datasets',
    badge: {
      color: 'accent3',
      text: 'Dataset'
    },
  },
  {
    label: 'Create New',
    value: 'experiment/create',
    category: 'Experiment',
    badge: {
      color: 'accent3',
      text: 'Experiment'
    },
  },
  {
    label: 'Import',
    value: 'module/import',
    category: 'Module',
    badge: {
      color: 'accent3',
      text: 'Module'
    },
  },
  {
    label: 'Create New',
    value: 'applications/new',
    category: 'Application',
    badge: {
      color: 'accent3',
      text: 'Application'
    },
  },
  {
    label: 'Create New',
    value: 'profiles/create',
    category: 'Profile',
    badge: {
      color: 'accent0',
      text: 'Profile'
    },
  },
  {
    label: 'Create New',
    value: 'reports/setup',
    category: 'Report',
    badge: {
      color: 'accent1',
      text: 'Report'
    },
  },
  {
    label: 'Create New',
    value: 'dashboard/create',
    category: 'Dashboard',
    badge: {
      color: 'accent2',
      text: 'Dashboard'
    },
  },
  {
    label: 'Create New',
    value: 'incident/create-board',
    category: 'Incidents',
    badge: {
      color: 'accent0',
      text: 'Incident Board'
    },
  }
]

export const quickActionCategories = [
  {
    label: 'Datasets',
    value: 'Datasets'
  },
  {
    label: 'Experiment',
    value: 'Experiment'
  },
  {
    label: 'Module',
    value: 'Module'
  },
  {
    label: 'Application',
    value: 'Application'
  },
  {
    label: 'Profile',
    value: 'Profile'
  },
  {
    label: 'Report',
    value: 'Report'
  },
  {
    label: 'Dashboard',
    value: 'Dashboard'
  },
  {
    label: 'Incidents',
    value: 'Incidents'
  }
]

export const searchContextMap = (contextType, data) => {

  if (contextType && data) {
    const contextMap = {
      'Application': {
        label: 'Application',
        url: `applications/${data.value}`,
        color: 'accent3'
      },
      'AI Model': {
        label: 'AI Model',
        url: `models/${data.value}`,
        color: 'accent3'
      },
      'Dataset': {
        label: 'Dataset',
        url: `dataset/${data.value}`,
        color: 'accent3'
      },
      'Profile': {
        label: 'Profile',
        url: `profiles/${data.value}`,
        color: 'accent0'
      },
      'Model Training Job': {
        label: 'Model Training Job',
        url: `job-training?name=${data.label}`,
        color: 'accent3'
      },
      'Location': {
        label: 'Location',
        url: `locations/${data.value}`,
        color: 'accent4'
      },
      'Data Collection': {
        label: 'Data Collection',
        url: `video/${data.value}`,
        color: 'accent3'
      },
      'Building Block': {
        label: 'Building Block',
        url: `modules/${data.value}`,
        color: 'accent3'
      },
      'Annotation Task': {
        label: 'Annotation Task',
        url: `annotation-jobs?taskId=${data.value}&taskName=${data.label}&status=completed`,
        color: 'accent3'
      },
      'Experiment': {
        label: 'Experiment',
        url: `job-training?name=${data.label}`,
        color: 'accent3'
      },
      'Role': {
        label: 'Role',
        url: `settings/role/${data.value}`,
        color: 'accent4'
      },
      'Notification': {
        label: 'Notification',
        url: `notifications/${data.value}`,
        color: 'accent3'
      },
      'Device Image': {
        label: 'Device Image',
        url: `device-image/${data.label}/false`,
        color: 'accent0'
      },
      'User': {
        label: 'User',
        url: `settings/user/${data.value}`,
        color: 'accent4'
      },
      'Incident': {
        label: 'Incident',
        url: `incident/${data.value}`,
        color: 'accent0'
      },
      'Report': {
        label: 'Report',
        url: `reports/${data.value}`,
        color: 'accent1'
      },
      'Incident Board': {
        label: 'Incident Board',
        url: `incident-board/${data.value}`,
        color: 'accent0'
      },
      'Dashboard': {
        label: 'Dashboard',
        url: `dashboards/${data.value}`,
        color: 'accent2'
      },
      'Device': {
        label: 'Device',
        url: `devices/${data.value}`,
        color: 'accent0'
      }
    }

    return contextMap[contextType]
  }
}